var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('li',{on:{"click":_vm.run}},[_c('v-icon',{attrs:{"left":"","color":"green"}},[_vm._v("$vuetify.icons.screenshot")]),_vm._v(" Odeslat výřez mapy ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }